@for (graph of graphs(); track $index) {
  <app-card [class]="[graph.type]">
    @if (graph.type === "group") {
      <app-metrics-graph-group
        [class]="[graph.type === 'group' ? graph.variant : '']"
        [graphs]="graph.graphs"
        [filters]="filters()"
      />
    } @else if (graph.type === "blocks") {
      <div class="blocks-container">
        @for (element of graph.data; track idx; let idx = $index) {
          <app-metric-card
            [data]="{
              title: element.title,
              subtitle: calculateDate(),
              count: element.value,
              countSubtitle: element.label,
            }"
          />
        }
      </div>
    } @else {
      <app-metrics-graph-title [title]="graph.title" [filters]="filters()" />
      <app-graph
        [data]="graph.data"
        [options]="graph.options"
        [style.height.px]="graph.height"
        [plugins]="graph.plugins"
        [type]="graph.type"
      />
    }
  </app-card>
}
